import React from 'react';

import { Grid, GridItem } from 'common/components/Grid';
import { GrowthbookFlag } from 'common/constants/feature-flags';
import { useFeatureFlagIsOn } from 'common/hooks/feature-flags';
import type { Color } from 'common/theme/colors/types';
import Banner from './banner';
import { PrismicSliceType } from './enums';
import FullWidthContainer from './shared/components/containers/FullWidthContainer';
import Teaser from './teaser';
import type { BannerProps, TeaserProps } from './types';

type CommonBannerProps = Omit<TeaserProps, 'tracking'> | Omit<BannerProps, 'tracking'>;

export const COMMON_BANNER_COMPONENTS = {
  [PrismicSliceType.TopTeaser]: (props: CommonBannerProps) =>
    React.createElement(Teaser, props as TeaserProps),
  [PrismicSliceType.TopBanner]: (props: CommonBannerProps) =>
    React.createElement(Banner, props as BannerProps),
};

const CommonBanner = (props: CommonBannerProps) => {
  const { backgroundColor, isViewportWide } = props;

  const dynamicCMS = useFeatureFlagIsOn(GrowthbookFlag.DynamicCMS);
  const sharedProps = {
    'data-corgi-id': 'common-banner',
    'data-ab-dynamic-cms': dynamicCMS ? 'true' : 'false',
  };

  const renderComponent = COMMON_BANNER_COMPONENTS[props?.type];
  if (!renderComponent) {
    return null;
  }

  const Component = renderComponent(props);

  if (isViewportWide) {
    return (
      <FullWidthContainer
        {...sharedProps}
        data-testid="grid-wrapper"
        backgroundColor={backgroundColor as Color}
      >
        {Component}
      </FullWidthContainer>
    );
  }

  return (
    <Grid {...sharedProps}>
      <GridItem>{Component}</GridItem>
    </Grid>
  );
};

export default CommonBanner;
